import React from 'react';
import KickImage from 'Reuseables/KickImage';

/* COMPONENTS */
import InitialProcess from './InitialProcess';
import AddPaymentMethod from './AddPaymentMethod';
import KredivoAsSplitPayment from './KredivoAsSplitPayment';
import AtomeAsSplitPayment from './AtomeAsSplitPayment';
import AkulakuAsSplitPayment from './AkulakuAsSplitPayment';

interface paymentMethod {
  type?: string;
  logo: string;
  label: string;
  active: boolean;
  payment_group: number;
  payment_method: string;
}

interface kredivoInstallment {
  label: string;
  monthly_installment: number;
  value: string;
}

interface dataAkulaku {
  tenure: number;
  monthly_installment: number;
}

interface availableMethod {
  type: string;
  logo: string;
  label: string;
  active: boolean;
  payment_group: number;
  payment_method: string;
}

interface balanceUsage {
  kickPoint: 0;
  kickCredit: 0;
  sellerCredit: 0;
  remainingPayment: 0;
}

type KickCreditProcessProps = {
  isSubmit: boolean;
  isUseVoucher: boolean;
  balance: string;
  atomePrice: string;
  dataAkulaku: Array<dataAkulaku>;
  isIndonesian: boolean;
  balanceUsage: balanceUsage;
  amountToBePaid: string;
  locked_balance: string;
  isSplitPayment: boolean;
  balance_with_fee: string;
  availableMethods: Array<availableMethod>;
  _installmentsList: Array<kredivoInstallment>;
  kickCreditProcess: string;
  isKickPointActive: boolean;
  isKickCreditActive: boolean;
  currentPaymentMethod: paymentMethod;
  isOpenModalBalanceInfo: boolean;
  isResponsive: boolean;
  selectedSplitPaymentMethod: paymentMethod | null;
  selectedSplitKredivoInstallment: kredivoInstallment | null;
  handleSubmit: () => void;
  handleSetAtomePrice: () => void;
  handleUsageBalance: (wallet_type: string, args: boolean) => void;
  setCheckoutProcess: (args: string) => void;
  setKickCreditProcess: (args: string) => void;
  setIsKickPointActive: (args: boolean) => void;
  setIsKickCreditActive: (args: boolean) => void;
  setIsModalBalanceInfo: (args: boolean) => void;
  setCurrentPaymentMethod: (args: Object) => void;
  setSelectedSplitPaymentMethod: (
    args: paymentMethod | kredivoInstallment | null,
  ) => void;
  handleFetchKredivoInstallments: () => void;
  setSelectedSplitKredivoInstallment: (item: kredivoInstallment | null) => void;
};

const KickCreditProcess: React.FC<KickCreditProcessProps> = ({
  isSubmit,
  isUseVoucher,
  balance,
  atomePrice,
  isResponsive,
  dataAkulaku,
  isIndonesian,
  balanceUsage,
  isSplitPayment,
  amountToBePaid,
  locked_balance,
  availableMethods,
  balance_with_fee,
  _installmentsList,
  kickCreditProcess,
  isKickPointActive,
  isKickCreditActive,
  currentPaymentMethod,
  isOpenModalBalanceInfo,
  selectedSplitPaymentMethod,
  selectedSplitKredivoInstallment,
  handleSubmit,
  handleSetAtomePrice,
  setCheckoutProcess,
  handleUsageBalance,
  setIsKickPointActive,
  setIsKickCreditActive,
  setKickCreditProcess,
  setIsModalBalanceInfo,
  setCurrentPaymentMethod,
  setSelectedSplitPaymentMethod,
  handleFetchKredivoInstallments,
  setSelectedSplitKredivoInstallment,
  userCurrency,
  variantPaymentMethods
}): JSX.Element => {
  return (
    <>
      {kickCreditProcess === '' && (
        <InitialProcess
          balance={balance}
          balanceUsage={balanceUsage}
          amountToBePaid={amountToBePaid}
          locked_balance={locked_balance}
          isSplitPayment={isSplitPayment}
          balance_with_fee={balance_with_fee}
          isKickPointActive={isKickPointActive}
          currentPaymentMethod={currentPaymentMethod}
          isOpenModalBalanceInfo={isOpenModalBalanceInfo}
          selectedSplitPaymentMethod={selectedSplitPaymentMethod}
          handleSubmit={handleSubmit}
          handleUsageBalance={handleUsageBalance}
          setCheckoutProcess={setCheckoutProcess}
          setIsKickPointActive={setIsKickPointActive}
          setKickCreditProcess={setKickCreditProcess}
          setIsModalBalanceInfo={setIsModalBalanceInfo}
          setCurrentPaymentMethod={setCurrentPaymentMethod}
          setSelectedSplitPaymentMethod={setSelectedSplitPaymentMethod}
          handleFetchKredivoInstallments={handleFetchKredivoInstallments}
          isSubmit={isSubmit}
          handleSetAtomePrice={handleSetAtomePrice}
          isKickCreditActive={isKickCreditActive}
          setIsKickCreditActive={setIsKickCreditActive}
          isResponsive={isResponsive}
          userCurrency={userCurrency}
          variantPaymentMethods={variantPaymentMethods}
          isUseVoucher={isUseVoucher}
        />
      )}
      {kickCreditProcess === 'add-payment-method' && (
        <AddPaymentMethod
          _installmentsList={_installmentsList}
          availableMethods={availableMethods}
          balanceUsage={balanceUsage}
          dataAkulaku={dataAkulaku}
          isIndonesian={isIndonesian}
          setKickCreditProcess={setKickCreditProcess}
          setSelectedSplitPaymentMethod={setSelectedSplitPaymentMethod}
          isResponsive={isResponsive}
        />
      )}
      {kickCreditProcess === 'split-kredivo-as-payment' && (
        <KredivoAsSplitPayment
          _installmentsList={_installmentsList}
          balanceUsage={balanceUsage}
          selectedSplitKredivoInstallment={selectedSplitKredivoInstallment}
          setCurrentPaymentMethod={setCurrentPaymentMethod}
          setKickCreditProcess={setKickCreditProcess}
          setSelectedSplitKredivoInstallment={
            setSelectedSplitKredivoInstallment
          }
          setSelectedSplitPaymentMethod={setSelectedSplitPaymentMethod}
        />
      )}
      {kickCreditProcess === 'split-atome-as-payment' && (
        <AtomeAsSplitPayment
          atomePrice={atomePrice}
          _installmentsList={_installmentsList}
          balanceUsage={balanceUsage}
          selectedSplitKredivoInstallment={selectedSplitKredivoInstallment}
          setCurrentPaymentMethod={setCurrentPaymentMethod}
          setKickCreditProcess={setKickCreditProcess}
          setSelectedSplitKredivoInstallment={
            setSelectedSplitKredivoInstallment
          }
          setSelectedSplitPaymentMethod={setSelectedSplitPaymentMethod}
        />
      )}
      {kickCreditProcess === 'split-akulaku-as-payment' && (
        <AkulakuAsSplitPayment
          dataAkulaku={dataAkulaku}
          balanceUsage={balanceUsage}
          setCurrentPaymentMethod={setCurrentPaymentMethod}
          setKickCreditProcess={setKickCreditProcess}
          setSelectedSplitPaymentMethod={setSelectedSplitPaymentMethod}
        />
      )}
    </>
  );
};

export default KickCreditProcess;
